import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="mb-4 md:mb-0">
            <img 
              src="https://customer-assets.emergentagent.com/job_estate-portfolio-9/artifacts/7gyu41ux_RiseRealEstate%20-%20Logos-06.png" 
              alt="RISE Real Estate Group" 
              className="h-16 w-auto"
            />
          </div>
          
          <div className="text-gray-400 text-sm text-center md:text-left">
            <p>© {new Date().getFullYear()} RISE Real Estate Group. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;